// components/RecommendedStarButton.tsx
import React, { useEffect, useMemo, useState } from "react";
import { Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Cnt } from "../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { AppSettings } from "../../AppSettings";
import { useUser } from "../../context/UserProvider";

type Props = {
  modelId: string;               // your "id is the model id"
  size?: number;                 // px size of the icon
  initialIsRecommended?: boolean // optional: if parent already knows
};

export const RecommendedStarButton: React.FC<Props> = ({
  modelId,
  size = 26,
  initialIsRecommended
}) => {

  const { user } = useUser();
  const isAdmin = user?.IsAdmin === true;

  const [isRecommended, setIsRecommended] = useState<boolean | null>(
    initialIsRecommended ?? null
  );
  const [saving, setSaving] = useState(false);

  const toggle = async () => {
    if (saving || isRecommended === null) return;
    const next = !isRecommended;
    setSaving(true);

    try {

        var api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
      // Call your provided SDK method (GET to /api/Model/SetRecommendation/{id}/{isRecommended})
      const dto = await api.model.SetRecommendation(modelId, next);
      const result =
        dto?.IsRecommended ?? next;
      setIsRecommended(!!result);
    } catch (e) {
      // revert on failure
      setIsRecommended(isRecommended);
      console.error("Failed to set recommendation:", e);
    } finally {
      setSaving(false);
    }
  };

  const StarSolid = (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="recommended">
      <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill="#f8d047"/>
    </svg>
  );
  const StarGrey = (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="not recommended">
      <path d="M22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24z" fill="#c0c0c0"/>
    </svg>
  );

  return (
    <div className="position-absolute" style={{ top: 8, left: 8, zIndex: 3 }}>
<OverlayTrigger
  placement="right"
  overlay={
    <Tooltip>
      {isRecommended ? "Unmark as recommended" : "Mark as recommended"}
    </Tooltip>
  }
>
  <span>
    {isAdmin && (
      <button
        type="button"
        onClick={toggle}
        disabled={saving || isRecommended === null}
        aria-pressed={!!isRecommended}
        aria-label={isRecommended ? "Unmark as recommended" : "Mark as recommended"}
        className="border-0 bg-transparent p-0"
        style={{
          cursor: saving ? "default" : "pointer",
          lineHeight: 0,
          filter: saving ? "grayscale(60%) opacity(0.6)" : "none",
        }}
      >
        {saving ? (
          <Spinner animation="border" size="sm" />
        ) : isRecommended ? (
          StarSolid
        ) : (
          StarGrey
        )}
      </button>
    )}

    {!isAdmin && isRecommended && (
      <div
        className="p-0"
        style={{
          lineHeight: 0,
          cursor: "default",
        }}
      >
        {StarSolid}
      </div>
    )}
  </span>
</OverlayTrigger>

    </div>
  );
};
